import { ListingAPI, ListingType, ListingUI } from "features/Dealers/Listings/state/types";
import { ListingSyncErrorsAPI, ListingSyncErrorsUI, SyncErrorsFields } from "features/Dealers/Listings/state/types";
import { DealerListingsWithErrorsAPI, DealerListingsWithErrorsUI } from "features/Dealers/Listings/state/types";
import { ChangedInfoAPI, ChangedInfoUI, ChangedListingInfoUI, ListingDB } from "features/Dealers/Listings/state/types";

export const parseChangedInfoAPI = (api: ChangedInfoAPI): ChangedInfoUI => {
    let changedListingsInfoUI: ChangedListingInfoUI[] = [];
    for (let i=0;i<api.changedListingsInfo.length;i++) {
        let changedListingInfoUI: ChangedListingInfoUI = {listing: parseListingDB(api.changedListingsInfo[i].listing), departmentName: api.changedListingsInfo[i].departmentName, fieldsChanged: api.changedListingsInfo[i].fieldsChanged};
        changedListingsInfoUI.push(changedListingInfoUI);
    }
    let changedInfoUI: ChangedInfoUI = {changedListingsInfo: changedListingsInfoUI}
    return changedInfoUI;
}

export const parseListingDB = (db: ListingDB): ListingUI => {
    
    return {
        id: db.id,
        dealerId: db.dealerId,
        type: db.listingType,
        idInSource: db.idInSource,
        engineId: db.engineId,
        deparmentId: db.listingType === ListingType.DEPARTMENT ? db.listingTypeId : undefined,
        statusSync: db.statusSync
    }
}

export const parseListingAPI = (api: ListingAPI): ListingUI => {
    
    return {
        id: api.id,
        dealerId: api.dealerId,
        type: api.listingType,
        idInSource: api.idInSource,
        engineId: api.engineId,
        deparmentId: api.listingType === ListingType.DEPARTMENT ? api.listingTypeId : undefined,
        statusSync: api.statusSync
    }
}

export const parseListingSyncErrosAPI = (api: ListingSyncErrorsAPI): ListingSyncErrorsUI => {
    return {
        listingId: api.listingId,
        generalError: api.generalError,
        fieldsErrors: api.fieldsErrors
    }
}

export const parseDealerListingsWithErrosAPI = (api: DealerListingsWithErrorsAPI[]): DealerListingsWithErrorsUI[] => {
    return api.map(apiErrorData => {
        return {
            listingId: apiErrorData.listingId,
            hasErrors: apiErrorData.hasErrors
        }
    })
}
